export const getUser = () => {
    const USER_UNPARSED = window.localStorage.getItem("user")
  if(USER_UNPARSED){
      return JSON.parse(USER_UNPARSED)
  }else return {};
};

export const getUserType = () => {
  const USER = getUser();
  if (USER) {
    return USER.type;
  } else return "none";
};